import React from "react";
import { ContactoInicio } from "../components/Inicio/Contacto";
import { Helmet, HelmetProvider } from "react-helmet-async";


const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Organization",
            "name": "Hod",
            "url": "https://www.hodvending.cl/contacto",

            "sameAs": [
                "https://www.facebook.com/profile.php?id=61557919715539",
                "https://www.instagram.com/hodvending",
                "https://www.linkedin.com/company/hod-servicios-logísticos/",
                "https://x.com"
            ]
        },
        {
            "@type": "LocalBusiness",
            "name": "HOD Servicios Logísticos ",

            "description": "   Solicita una cotización personalizada para tu empresa. Asesoría experta para elegir el modelo Jofemar ideal para tu espacio.",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Dirección de su negocio",
                "addressLocality": "Ciudad",
                "addressRegion": "Región",
                "postalCode": "Código Postal",
                "addressCountry": "CL"
            },
            "priceRange": "$$",
            "openingHours": "Mo-Fr 08:00-17:00",
            "url": "https://www.hodvending.cl/contacto"
        },
        {
            "@type": "WebPage",
            "name": "Productos",
            "url": "https://www.hodvending.cl/contacto",
            "datePublished": "2024-07-01",
            "description": "  Solicita una cotización personalizada para tu empresa. Asesoría experta para elegir el modelo Jofemar ideal para tu espacio.",
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.hodvending.cl/contacto"
            }
        }
    ]
};
export const IndexContacto = () => {
     <HelmetProvider>
                    <Helmet>
                        <title> 
                             Cotiza tu Máquina Vending Jofemar | HOD Chile
                        </title>
                        <meta
                            name="description"
                            content="  Solicita una cotización personalizada para tu empresa. Asesoría experta para elegir el modelo Jofemar ideal para tu espacio.
    
                     
                            "
                        />
                        <meta
                            name="keywords"
                            content="cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile"
                        />
                        <meta
                            property="og:description"
                            content="  Solicita una cotización personalizada para tu empresa. Asesoría experta para elegir el modelo Jofemar ideal para tu espacio.
    
                     "
                        />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://www.hodvending.cl/contacto" />
                        <meta property="og:title" content="  Cotiza tu Máquina Vending Jofemar | HOD Chile
    " />
                        <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
                        <meta name="author" content="HOD Servicios Logísticos " />
                        <meta name="robots" content="index,follow" />
                        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                        <meta name="publisher" content="HOD Servicios Logísticos " />
                        <link rel="canonical" href="https://www.hodvending.cl/contacto" />
                        <script type="application/ld+json">
                            {JSON.stringify(schemaData)}
                        </script>
                    </Helmet>
                </HelmetProvider>
    return(
        <>
         <h1 style={{color:'transparent', position:'absolute'}}> cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile, empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, servicio técnico vending, instalación máquinas vending, mantenimiento vending, soporte postventa, asistencia vending, repuestos Jofemar</h1>
            <ContactoInicio/>
        
        </>
    )
}